import React from "react";
import { Box, Grid2, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";

import dashboard from "../../../../Images/EAM/Dashboard.png";
import formList from "../../../../Images/EAM/formlist.png";
import formPage from "../../../../Images/EAM/formpage.png";
import wave from "../../../../Images/aboutUsBg.jpg";
// import wave from "../../../../Images/aboutUsBg.jpg";
import { commonCss } from "../../../../CssStyle/commonCss";
import WaveBackground from "../../../../Component/WaveBackground";
import { ArrowForward } from "@mui/icons-material";

const EAM = () => {
  return (
    <Grid2 container spacing={"2rem"} >
     <WaveBackground menu={"Our Products"} title={"Enterprise Asset Management"} description={"Enhancing Psset Performance Through Strategic Lifecycle Management."}/>
    

     <Grid2 container justifyContent={"center"}>
           <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"0 3rem 3rem 3rem"},maxWidth:{xs:"auto",xl:"2000px"}}} alignItems={"center"} mt="-10%" >
             <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-start"}}>
            {/* <Box sx={{display:'flex',width:"100%",height:"fit-content",alignItems:"center",gap:"1rem"}}>
            <img src={dashboard} style={{width:'60%',height:"50vh",borderRadius:"10px",border:"5px solid #474747"}}/>
            <img src={dashboard_mobile} style={{width:'20%',height:"40vh",borderRadius:"10px",border:"5px solid #474747"}}/>
            </Box> */}
            <img src={dashboard} style={{width:'85%',height:"100%"}}/>
        </Grid2>
        <Grid2 size={{xs:12,md:6}} sx={{pr:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},textAlign:{xs:"center",md:"left"},fontWeight:700,fontFamily:"inherit"}}>EAM Web & Mobile App</Typography>
            <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Enterprise Asset Management (EAM) solution</span> designed to optimize the management of your organization’s assets throughout their entire lifecycle, from asset acquisition to disposal. Oriens EAM empowers you to maximize asset performance, minimize downtime, and drive
operational efﬁency across your enterprise. Say goodbye to fragmanted asset management processes and embrace a uniﬁed approach with our cutting-edge EAM Solution.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography>
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1rem",
              fontWeight:600
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:1,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Assest Management
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Workorder Management
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Inventory Management
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Mobile EAM</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>IIOT Management
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Integration Management</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Health, Safety & Environment (HSE) Management </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>KPI & Dashboard</ListItemText>
                </ListItem>
            </List>
        </Grid2>
     </Grid2>
     </Grid2>
     <Grid2 container justifyContent={"center"} sx={{background:commonCss.backgroundGray}} >
          <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"3rem"},maxWidth:{xs:"auto",md:"2000px"}}} alignItems={"center"}>
     <Grid2 size={{xs:12,md:6}} sx={{pl:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},fontWeight:700,fontFamily:"inherit"}}> Transform your assest management practices, drive operational excellence and unlock new levels of efficiency and productivity.
</Typography>
            <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>Why Use EAM?
</Typography>
            
            {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1rem",
              fontWeight:600
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:4,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Regular maintenance and monitoring reduce wear and tear.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Proactive maintenance minimizes unexpected failures.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Efficient resource management cuts maintenance and operational expenses.
                  </ListItemText>
                </ListItem>
              
            </List>
        </Grid2>
        <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-end"}}>
        <img src={formList} style={{width:'85%',height:"100%"}}/>
        </Grid2>
      
     </Grid2>
     </Grid2>
  <Grid2 container justifyContent={"center"}>
     <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"3rem"},maxWidth:{xs:'auto',xl:"2000px"}}} alignItems={"center"}  >
        <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-start"}}>
        <img src={formPage} style={{width:'85%',height:"100%"}}/>
        </Grid2>
        <Grid2 size={{xs:12,md:6}} sx={{pr:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},fontWeight:700,fontFamily:"inherit"}}>Benefits</Typography>
            {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1.1rem",
              fontWeight:400
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:1,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Improved the assest performance.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Reduced downtime.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Cost savings</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Enhanced decision-making.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Increased efficiency.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Improved compliance </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Risk mitigation</ListItemText>
                </ListItem>
            </List>
        </Grid2>
     </Grid2>
     </Grid2>
    </Grid2>
  );
};

export default EAM;
